import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Create, FormManager, PageTitle, selectUser, UserState } from 'gossamer-front-end';
import { getListRowLink } from 'gossamer-unified';
import { Location } from 'cb-model';
import { useSelector } from 'react-redux';
import { CustomInfo } from 'cb-unified';

export const LocationCreate = (): React.JSX.Element => {
  const navigate = useNavigate();
  const user = useSelector((state: { user: UserState }) => selectUser(state));

  return (
    <>
      <PageTitle verb="Create" entity={Location} />
      {user.userId && (
        <FormManager
          compoundUrl="/main/~/location-create"
          handleCancel={() => navigate(`/admin/location/search`)}
          handleSuccess={({ keyOfFirstCreate }) => navigate(getListRowLink(Location.listRowLink, keyOfFirstCreate))}
          initialization={{
            main: {
              type: 'create-single',
              entity: Location,
              override: {
                institution_id: (user.customInfo as CustomInfo)?.adminInstitutionId,
              },
            },
          }}
        >
          <Create valuesKey="main" entity={Location} />
        </FormManager>
      )}
    </>
  );
};
